<template>
    <nav
        v-if="page.last_page > 1"
        aria-label="Pagination"
        class="flex items-center gap-4 py-6 text-sm"
    >
        <Link v-if="previous" :href="previous" class="underline">Previous</Link>
        <span>Page {{ page.current_page }} of {{ page.last_page }}</span>
        <Link v-if="next" :href="next" class="underline">Next</Link>
    </nav>
</template>
<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
defineProps<{
    page: { current_page: number; last_page: number };
    previous?: string;
    next?: string;
}>();
</script>
